module.exports = __webpack_public_path__ + "static/Thumb_FTL_CityDriving_ThreeDiferemtType_Tex-b8f696efc1b69a54702c7102e78cea95.png";